export default __webpack_public_path__ + "static/minalice-baa961f1fc58d7f0537f449e76ec0b79.jpg";